<template id="exit">
    <div class="exitway">
        <div class="exitway_cont">
            <div class="header">
            <div class="container">
                
                <div class="back" @click="goToLastStep"> 
                    <span class="icon icon-dropdown_up"></span> <span class="text">Indietro</span>
                </div>

                <!-- <span class="title" @click="goToConfigSummary()">Modifica le tue risposte</span> -->
                <!--
                    <div class="info">
                    <div>exit id: {{ exitid }}</div>
                </div>
                -->
                <div class="sf-close" sf-cart-modal-close @click="closeCartStep()">
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>

        <div v-if="(actions.length == 1)&&(actions[0].type=='ko')" class="container inside">

            <div class="claim-container">
                <div class="claim" v-html="claim"></div>
                <div class="subclaim" v-html="subclaim"></div>
            </div>

            <div class="row padded">
                <div v-for="( action ) in actions" v-bind:key="action" class="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-sm-12 col-xs-12" >

                    <exit-card
                        :exitlist="exitlist" 
                        :payment="payment"
                        :commodity="commodity"
                        :type="action.type"
                        :supply="action.supply" 
                        :text="action.text" 
                        :text_docs="action.text_docs"
                        :btn_label="action.btn_label" 
                        :btn_url="goToUrl(action.btn_url, action.supply)"
                        :underbox_title="action.underbox_title"
                        :underbox_text="action.underbox_text"
                        :event_category="action.eventCategory"
                        :total_ko=true
                    >
                    </exit-card>
                </div>

            </div>
        </div>
        
        <div v-else :class="[actions.length == 1 ? 'container withimage bkg-image' : 'container inside' ]">

            <!-- <div v-if="actions">{{actions.length}}</div> -->

            <div class="claim-container">
                <div class="claim" v-html="claim"></div>
                <div class="subclaim" v-html="subclaim"></div>
            </div>
            
            <div class="row padded">

                <!-- singolo e centrato col-lg-6 col-md-6 col-sm-12 col-xs-12 bordered' : 'col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-sm-12 col-xs-12 -->

                <div v-for="( action ) in actions" v-bind:key="action" :class="[ actions.length == 2 ? 'col-lg-6 col-md-12 col-sm-12 col-xs-12 bordered' : 'col-lg-12 col-md-12 col-sm-12 col-xs-12' ]" >
                    <exit-card
                        :exitlist="exitlist" 
                        :payment="payment"
                        :commodity="commodity"
                        :type="action.type"
                        :supply="action.supply" 
                        :text="action.text" 
                        :text_docs="action.text_docs"
                        :btn_label="action.btn_label" 
                        :btn_url="goToUrl(action.btn_url, action.supply)"
                        :underbox_title="action.underbox_title"
                        :underbox_text="action.underbox_text"
                        :event_category="action.eventCategory"
                        :total_ko=false
                    >
                    </exit-card>
                </div>

            </div>

        </div>

        </div>
    </div>
</template>


<script>

import ExitCard from './ExitCard.vue';
import Url from "./../helpers/Url.js";
import Obj from "./../helpers/Obj.js";

export default {
    template: '#exit',
    
    components: {
        ExitCard
    },
    
    props: ['exitlist', 'exitid', 'fare', 'payment', 'bill'],
    data: function () {
        return {
            value: -1
        };
    },
    created: function () { 

        console.log("exitlist --->", this.exitlist);
        console.log("exitid --->", this.exitid);

        //console.log("changeconfig --->", this.changeconfig);

        //let origin = window.location.origin;

        this.url_myeni = '/my-eni',
		//this.url_nuovaFornitura = '/offerta/casa/nuova-fornitura',
		this.url_nuovaFornituraLuce = '/offerta/casa/nuova-fornitura/luce',
		this.url_nuovaFornituraGas = '/offerta/casa/nuova-fornitura/gas',
        this.url_voltura = '/offerta/casa/nuova-fornitura/voltura';

        let list = this.exitlist;

        function getExit(id) {
            return list.filter(
                function(list){return list.id == id}
            );
          }
         
        this.exit = getExit(this.exitid);
        //console.log("this.exit", this.exit);

        this.type = this.exit[0].type;
        this.claim = this.exit[0].claim;
        this.subclaim = this.exit[0].subclaim;
        this.actions = this.exit[0].actions;
        this.supply = this.exit[0].supply;
        this.text = this.exit[0].text;
        this.text_docs = this.exit[0].text_docs;
        this.btn_label = this.exit[0].btn_label;
        this.btn_url = this.exit[0].btn_url;
        this.underbox_title = this.exit[0].underbox_title;
        this.underbox_text = this.exit[0].underbox_text;
        this.event_category = this.exit[0].event_category;


        switch (this.exitid[1]){
            case "1":
                this.commodity = "gaseluce";
                this.codiceProdotto = 'WEB221_LLINKV221-GLINKV221';
                this.codiceOfferta = 'WEB221_LLINKV221-GLINKV221';
              break;
            case "2":
                this.commodity = "luce";
                this.codiceProdotto = 'WEB221_LLINKV221';
                this.codiceOfferta = 'WEB221_LLINKV221';
            break;
            case "3":
                this.commodity = "gas";
                this.codiceProdotto = 'WEB221_GLINKV221';
                this.codiceOfferta = 'WEB221_GLINKV221';
            break;
        }

    },
    beforeMount: function () {
    },

    methods: {

        goWeborder: function( event ) {
            console.log("event", event);

            //urlesempio="https://www.enigaseluce.com/attiva-offerta-casa/index.html?codiceProdotto=PROMO213_GLINKV213&codiceOfferta=PROMO213_GLINKV213&commodity=gas&opzione=monoraria&bill-type=digitale&direct-debit=true&codiceCanale=CWEB3EGP&codiceTpCanale=WB&coupon=null";

            console.log(this.commodity);
            console.log(this.fare);
            console.log(this.payment);
            console.log(this.bill);

            if (this.bill == "cartaceo") {
                this.bill_url = "cartacea";
            } else {
                this.bill_url = this.bill;
            }

            if (this.payment == "addebito diretto") {
                this.directdebit_url = "true";
            } else {
                this.directdebit_url = "false";
            }

            const inputParams = {
                codiceConvenzione: Url.getParams("codiceConvenzione"),
                codiceAgente: Url.getParams("codiceAgente"),
                codiceTpCanale: Url.getParams("codiceTpCanale"),
                idPartner: Url.getParams("idPartner")
            }

            const defaultParams = {
                "codiceProdotto": this.codiceProdotto,
                "codiceOfferta": this.codiceOfferta,
                "commodity": this.commodity,
                "opzione": this.fare,
                "bill-type": this.bill_url,
                "direct-debit": this.directdebit_url,
                "codiceCanale": 'CWEB3EGP',
                "codiceTpCanale": 'WB',
                "coupon": 'null',
            }

            let base = "/attiva-offerta-casa/index.html?";
            let queryParams = defaultParams;
            if ( inputParams.codiceTpCanale ){
                queryParams = Obj.merge( defaultParams, inputParams );
            }

            let weborder_url = base + Obj.join( queryParams, '&' );
            console.log ("url goweborder", base, inputParams, queryParams);
            
            this.exiturl = weborder_url;
            //window.location.href = weborder_url;

            return this.exiturl;
        },


        goSwitch: function( event ) {

            //- force dual params submit --
            
            /*
            let query = $.param({
                "modal": "switch-accedi-registra",
                "redirPagina": 26,
                // "codiceProdotto": this.params[ 'gaseluce' ], 
                // "codiceOfferta": this.params[ 'gaseluce' ], 
                "codiceProdotto": this.params[ this.params.commodity ],
                "codiceOfferta": this.params[ this.params.commodity ],
                "commodity": this.params.commodity, 
                "opzione": this.params.option
            });

            this.redirectMe( window.location.origin+"/cambio-prodotto/index.html?"+query+'&'+this.params.extra );
            */
            
            console.log("event:", event);
            console.log(this.commodity);
            console.log(this.fare);
            console.log(this.payment);
            console.log(this.bill);

            //let href = window.location.origin + window.location.pathname;
            //let href = window.location.origin;
            let href = '/my-eni';

            let query = 'redirPagina=26&codiceProdotto='+this.codiceProdotto+'&codiceOfferta='+this.codiceOfferta+'&commodity='+this.commodity+'&opzione='+this.fare;
            let extra = 'codiceCanale=CWEB3EGP&codiceTpCanale=WB&chiamante=null';
            
            if (document.querySelectorAll(".open-mail").length > 0) {
                 //myeni loggato
                 console.log("utente loggato");
                this.exiturl = "/cambio-prodotto/index.html?"+query+'&'+extra;
                              //window.location.origin+"/cambio-prodotto/index.html?"+query+'&'+extra;
            } else {
                 //myeni non loggato
                 console.log("utente non loggato");
                this.exiturl = href+"?"+query+'&'+extra;
              //this.fillForm( href+'?'+query+'&'+this.params.extra );
            }

            
            console.log(this.exiturl);
            return this.exiturl;
            //return false;   
        },

        //*************** */ goswitch SM
        /*
        goSwitch: function( event ) {
            console.log('sf.cartModal', 'V4', 'goSwitch');

            // let href = window.location.origin + window.location.pathname;
            var href = '/my-eni';
            
            //- force dual params submit --
            let query = $.param({
                "modal": "switch-accedi-registra",
                "redirPagina": 26,
                // "codiceProdotto": this.params[ 'gaseluce' ], 
                // "codiceOfferta": this.params[ 'gaseluce' ], 
                "codiceProdotto": this.params[ this.params.commodity ],
                "codiceOfferta": this.params[ this.params.commodity ],
                "commodity": this.params.commodity, 
                "opzione": this.params.option
            });

            

            if ( $(".open-mail").length ){
                // redirect for logged user
                    if ( sfGetProducts.segmentoByCode( this.params[ this.params.commodity ] ) === 'BUSINESS' ){
                        this.redirectMe( window.location.origin+"/domm-cambioprodotto-web/it/eni/domm/cambioprodotto/web/ui/small/begin.do?"+query+'&'+this.params.extra );
                    } else {
                        this.redirectMe( window.location.origin+"/cambio-prodotto/index.html?"+query+'&'+this.params.extra ); // se loggato
                    }

                return false;
            }

            this.fillForm( href+'?'+query+'&'+this.params.extra ); //myeni non loggato
            $('#theForm').submit();

            return false;
        },
        */
        //*************** */ goswitch SM

        /*
        closeCartStep: function () {
            $('.link.open.cart-step').hide();
            $("#Link").removeClass("carrelloIn");
            $("#link").removeClass("carrelloIn");
            $("body").removeClass("overlay-open");
        },
        */

        goToUrl: function (url, supply) {

            console.log("supply:", supply);

            switch (url) {
                case "ko":
                    this.exiturl = this.window.location.href;
                  break;
                case "new":		
                    switch (supply) {
						case "Luce":
							this.exiturl = this.url_nuovaFornituraLuce;
						break;
						case "Gas":
							this.exiturl = this.url_nuovaFornituraGas;
						break;
					}
                break;
                case "voltura":
                    this.exiturl = this.url_voltura;
                break;

                case "myeni":
                    this.goSwitch();
                break;

                case "weborder":
                    this.goWeborder();
                break;

                default:
                    this.exiturl = window.location.href; // ricarica se non è nessuno dei casi
                break;
              } 

            return this.exiturl;
        },

        goToLastStep: function () {
            this.$emit('gotolaststep');
        },

        goToConfigSummary: function () {
            this.$emit('reconfig');
        },

        closeCartStep: function () {
            document.getElementById('cart-step').classList.remove('open');
        },
    }
}
</script>